/**
 * Code postal français (métropole / DOM courants) : exactement 5 chiffres.
 * Les espaces accidentels (début, fin, ou internes type "75 012") sont normalisés.
 */

export function normalizeFrenchPostalCode(value) {
  if (value == null) return '';
  return String(value).replace(/\s+/g, '').trim();
}

export function isValidFrenchPostalCode(value) {
  const normalized = normalizeFrenchPostalCode(value);
  return /^\d{5}$/.test(normalized);
}

/**
 * @returns {{ ok: true, value: string } | { ok: false, error: string }}
 */
export function validateFrenchPostalCode(value) {
  const normalized = normalizeFrenchPostalCode(value);
  if (!normalized) {
    return { ok: false, error: 'Le code postal est obligatoire' };
  }
  if (!/^\d{5}$/.test(normalized)) {
    return {
      ok: false,
      error: 'Le code postal doit contenir exactement 5 chiffres (ex. 75012)',
    };
  }
  return { ok: true, value: normalized };
}
